import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { withFormStyles } from '../styles';

class TypeForm extends React.Component {
    state = {
        value: '',
    };

    componentDidMount() {
        const { policy } = this.props;
        this.setState({ value: policy.value.policy || policy.policy.default });
    }

    handleChange = event => {
        this.setState({ value: event.target.value });
    };

    handleCancel = event => {
        this.setState({ value: '' });
    };

    handleSave = event => {
        const data = {
            uuid: this.props.policy.uuid,
            value: this.state.value,
            enabled: true,
        };
        this.props.onSave(data);
    };
    render() {
        const { classes, enabled, types, editable, label } = this.props;

        const disabled = !enabled || !editable;
        return (
            <>
                <div className={classes.formInput}>
                    <TextField
                        select
                        label={label}
                        disabled={disabled}
                        value={this.state.value}
                        onChange={this.handleChange}
                        className={classes.root}
                    >
                        {types.map(option => (
                            <MenuItem key={option.code} value={option.code}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
                <div>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleSave}
                    >
                        Save
                    </Button>
                </div>
            </>
        );
    }
}

export default withFormStyles(TypeForm);
